import Vue from "vue"
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [{
    path: '/',
    name: 'Home',
    component: () => import('@/views/home/Home')
  },
  {
    path: '/library',
    name: 'library',
    component: () => import('@/views/library/Library')
  },
  {
    path: '/detail',
    name: 'detail',
    component: () => import('@/views/library/Detail')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('@/views/about/About')
  },
  {
    path: '/reader',
    name: 'reader',
    component: () => import('@/views/reader/Reader')
  },
  {
    path: '*',
    name: '404',
    component: () => import('@/views/404/404')
  }
]

const router = new VueRouter({
  routes,
  // mode: 'history'
  base: "/frontend"
})

const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function (location) {
  return routerPush.call(this, location).catch(error => error)
}

export default router
